
import { useEffect, useState } from "react";

import { landingPagaData, locationPageData } from "../../Blc_Api/BlcLandingPageData/LandingPageData";

export function useModelTab(){
    const [modalshow, setModalShow] = useState(false);
  

    return[modalshow, setModalShow]
  }


  export function useFeedBack() {
    const [showFeed, setShowFeed] = useState(false);

    return[showFeed,setShowFeed]
  }


  

  

  export function useHomePagaData() {
     
    const [landingdata, setLandingData] = useState();
    
    
    useEffect(()=>{

      landingPagaData().then(val =>{
        setLandingData(val);
        //  console.log(val);
      })
      
    },[]);

    return([landingdata,setLandingData]);
  }